import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { useTranslation } from 'next-i18next'

export const InputNumber = ({
  value,
  setValue,
  minValue = 1,
  maxValue,
  size = 'small'
}: {
  value: number
  setValue: (value: number) => void
  minValue?: number
  maxValue: number
  size?: 'small' | 'large'
}) => {
  const { t } = useTranslation('common')
  const onSum = () => {
    const sum = value + 1
    if (sum <= maxValue) {
      setValue(sum)
    }
  }
  const onSubstract = () => {
    const substract = value - 1
    if (substract >= minValue) {
      setValue(substract)
    }
  }

  const isLarge = size === 'large'

  return (
    <div
      className={`${
        isLarge ? 'h-12.5' : 'h-10'
      } flex w-full items-center rounded-full border ${
        isLarge
          ? 'border-ink-100/40 hover:border-blue-500'
          : 'border-ink-100/15 hover:border-ink-100/40'
      } bg-white-500 transition-colors duration-200 focus-within:border-blue-500`}
    >
      <button
        type="button"
        onClick={onSum}
        disabled={value >= maxValue}
        aria-label={t('A11Y.INCREASE_QUANTITY')}
        className={`flex h-full items-center justify-center transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 ${
          isLarge
            ? 'rounded-l-full border-r border-ink-100/30 px-4 text-blue-500 hover:bg-blue-500/10 disabled:cursor-not-allowed disabled:text-cream-500 disabled:hover:bg-transparent'
            : 'px-4'
        }`}
      >
        <AddIcon
          sx={{ fontSize: isLarge ? 20 : 16 }}
          className={isLarge ? '' : 'text-ink-200'}
        />
      </button>
      <input
        className="w-full min-w-8 bg-transparent text-center focus:outline-none"
        value={value}
        aria-label={t('A11Y.QUANTITY')}
        onChange={(e) => {
          const value = Number(e.target.value)

          if (value >= minValue && value <= maxValue && !isNaN(value)) {
            setValue(value)
          }
        }}
      />
      <button
        type="button"
        onClick={onSubstract}
        disabled={value <= minValue}
        aria-label={t('A11Y.DECREASE_QUANTITY')}
        className={`flex h-full items-center justify-center transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 ${
          isLarge
            ? 'rounded-r-full border-l border-ink-100/30 px-4 text-blue-500 hover:bg-blue-500/10 disabled:cursor-not-allowed disabled:text-cream-500 disabled:hover:bg-transparent'
            : 'px-4'
        }`}
      >
        <RemoveIcon
          sx={{ fontSize: isLarge ? 20 : 16 }}
          className={isLarge ? '' : 'text-ink-200'}
        />
      </button>
    </div>
  )
}
